// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kn6eAiGgcLYolVFIS8qb{width:100%;max-width:620px;margin:0 auto;padding:0 20px 92px}@media (min-width:992px){.kn6eAiGgcLYolVFIS8qb{max-width:760px}}.XD0HH9Y_rlM2SHOik20d{scrollbar-gutter:stable;overflow-x:hidden;overflow-y:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `kn6eAiGgcLYolVFIS8qb`,
	"wrap": `XD0HH9Y_rlM2SHOik20d`
};
export default ___CSS_LOADER_EXPORT___;
